import {
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@sfc/ui";
import { CurrencyInput } from "./currency-input";

export function FormCurrencyInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  className,
  labelClassName,
  inputClassName,
  control,
  name,
  label,
  description,
  ...rest
}: React.ComponentProps<typeof CurrencyInput> &
  Omit<ControllerProps<TFieldValues, TName>, "render"> & {
    labelClassName?: string;
    inputClassName?: string;
    label?: string;
    description?: string;
  }) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          {label && <FormLabel className={labelClassName}>{label}</FormLabel>}
          <FormControl>
            <CurrencyInput
              className={inputClassName}
              value={field.value}
              onValueChange={field.onChange}
              {...rest}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
